import React, { useState } from "react";
import { Col, Container, Row, Modal } from "react-bootstrap";
import Video4 from "../../../images/landing/videos/VitruvianAgency.mp4";

import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";
import { Case_ArrowFlutterusa } from "../../../../app-constants";
import BannerForm from "../../components/bannerfrom";

const Slide4 = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <section className="project_lp">
        <Container className="h-100">
          <Row className="h-100">
            <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
              <div className="project_lp_main">
                <div className="project_slider_img">
                  <video autoPlay loop muted controls={false}>
                    <source src={Video4} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <div className="project_content">
                  <h6 style={{ color: "#B7061C" }}>Vitruvian Agency</h6>
                  <h2 style={{ color: "#B7061C" }}>250% Boost in PR Impact</h2>
                  <p>
                    Our collaboration with Vitruvian Agency resulted in a
                    dynamic web platform, ensuring businesses maximum PR impact
                    without compromising on results.
                  </p>
                  <div className="btn_main_lp">
                    <Link
                      to=""
                      className="project_btn_lp"
                      aria-label="TekRevol Contact"
                      onClick={handleShow}
                    >
                      Let’s Talk
                    </Link>
                    <span style={{ background: "#B7061C" }}>
                      {Case_ArrowFlutterusa}
                    </span>
                    <Link
                      to="/projects"
                      className="project_btn_lp2"
                      aria-label="TekRevol Contact"
                      style={{ color: "#B7061C" }}
                      target="_blank"
                    >
                      View Case study
                    </Link>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="landing_lp_popup"
      >
        <div className="modal_forms">
          <BannerForm setShow={setShow} />
        </div>
      </Modal>
    </>
  );
};

export default Slide4;
